const RESULTS_PER_PAGE = 20;

export { RESULTS_PER_PAGE };
